import { firestore } from "firebase";
import * as fs from "../firestore";

export type DeviceList = fs.DeviceList & {id: string};

export type WorkItem = {
    SerialNo: string,
    BluetoothAddress: string,
    Status: string,
    errorNotes: string
}

export function makeFetchDeviceMastersQuery() {
    const DeviceMastersRef = firestore().collection(fs.Collection.DeviceMasters);

    let query = DeviceMastersRef
        .orderBy("SerialNo", "desc" );
    return query;
}
